import { motion, AnimatePresence } from "framer-motion";

// 🎯 POG SCAN reticle — POINT/HOLD shows the targeting rings, RELEASE fires the radar sweep.
export const PogScanReticle = ({ fx }) => (
  <AnimatePresence>
    {fx && (
      <motion.div
        data-testid="pog-scan-reticle"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed z-[2500] pointer-events-none"
        style={{ left: fx.x, top: fx.y, transform: "translate(-50%, -50%)" }}
      >
        {fx.phase === "arming" ? (
          <div className="relative w-24 h-24 -translate-x-1/2 -translate-y-1/2" style={{ transform: "translate(-50%,-50%)" }}>
            <motion.span
              initial={{ scale: 1.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.35 }}
              className="absolute inset-0 rounded-full border-[3px] border-violet-400 shadow-[0_0_24px_rgba(139,92,246,0.85)]"
            />
            <span className="absolute inset-3 rounded-full border-2 border-indigo-300/70 animate-ping" />
            <span className="absolute left-1/2 top-0 h-3 w-1 bg-violet-300 -translate-x-1/2 rounded-full" />
            <span className="absolute left-1/2 bottom-0 h-3 w-1 bg-violet-300 -translate-x-1/2 rounded-full" />
            <span className="absolute top-1/2 left-0 w-3 h-1 bg-violet-300 -translate-y-1/2 rounded-full" />
            <span className="absolute top-1/2 right-0 w-3 h-1 bg-violet-300 -translate-y-1/2 rounded-full" />
            <span className="absolute left-1/2 top-1/2 w-2 h-2 rounded-full bg-violet-200 -translate-x-1/2 -translate-y-1/2 animate-pulse" style={{ boxShadow: "0 0 12px 4px rgba(167,139,250,0.9)" }} />
            <p className="absolute -bottom-7 left-1/2 -translate-x-1/2 text-[11px] font-heading font-black tracking-widest text-violet-200 whitespace-nowrap" style={{ textShadow: "0 1px 6px rgba(0,0,0,0.9)" }}>⚡ RELEASE TO WARP</p>
          </div>
        ) : (
          <div className="relative w-44 h-44" style={{ transform: "translate(-50%,-50%)" }}>
            <span className="absolute inset-0 rounded-full" style={{ background: "radial-gradient(circle, rgba(124,58,237,0.35) 0%, rgba(99,102,241,0.15) 55%, transparent 75%)" }} />
            {[0, 0.22, 0.44].map((d) => (
              <motion.span
                key={d}
                initial={{ scale: 0.15, opacity: 1 }} animate={{ scale: 2.6, opacity: 0 }}
                transition={{ duration: 1.05, delay: d, ease: "easeOut" }}
                className="absolute inset-0 rounded-full border-[3px] border-violet-400"
                style={{ boxShadow: "0 0 16px rgba(139,92,246,0.8)" }}
              />
            ))}
            <motion.span
              animate={{ rotate: 360 }} transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
              className="absolute inset-0 rounded-full"
              style={{ background: "conic-gradient(from 0deg, rgba(139,92,246,0.85) 0deg, rgba(99,102,241,0.4) 55deg, transparent 95deg)" }}
            />
            <span className="absolute left-1/2 top-1/2 w-3 h-3 rounded-full bg-violet-100 -translate-x-1/2 -translate-y-1/2" style={{ boxShadow: "0 0 22px 8px rgba(139,92,246,0.95)" }} />
            <p className="absolute -bottom-9 left-1/2 -translate-x-1/2 text-[13px] font-heading font-black tracking-widest text-violet-100 whitespace-nowrap animate-pulse" style={{ textShadow: "0 1px 8px rgba(0,0,0,0.95)" }}>🌀 POG'WARPING…</p>
          </div>
        )}
      </motion.div>
    )}
  </AnimatePresence>
);
